import React, { useEffect, useState, useCallback, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import { NavLink } from 'react-router-dom'
import { RouteComponentProps } from 'react-router-dom'
import useParsedQueryString from '../../hooks/useParsedQueryString'
import { BigNumber } from '../../sushi'

// components
import Loading from '../../components/Loader/Loading'
import { BodyHead, BodyTitle } from '../../components/bakery/styleds'
import NoArtworks from '../../components/nftInfo/NoArtworks'
import Artworks from '../../components/nftInfo/Artworks'
import { ButtonLight } from '../../components/Button'
import { SortOptions, TabOptions, ArtworkProps, AuctionBake } from '../../constants/artwork'
import { MARKETTYPE, MARKETTYPEV1, MARKETTYPEV3, MARKETMULTITOKEN } from '../../constants/bakery/nft'
import { compare } from '../../utils/func'
import Videos from '../binance/components/Videos'
import { Artworks as SoccerArtwork } from '../Soccer/components/Artworks'
import { Artworks as GameArtworks }  from '../../components/Gamification/Artworks'
import { InfoSolt as DoggyInfoSolt } from '../Doggies/components/InfoSolt'
import { InfoSolt as BarkInfoSolt } from '../Barking/components/InfoSolt'
import { InfoSolt as EquipmentInfoSolt } from '../DoggyEquipments/components/InfoSolt'
import { InfoSolt as PokerInfoSolt } from '../Poker/components/InfoSolt'
import { InfoSolt as CarInfoSolt } from '../Car/components/InfoSolt'
import ExchangeBakeVersion from '../../components/Gamification/ExchangeBakeVersion'
import StakeRow from '../../components/Gamification/StakeRow'

// hooks
import { useActiveWeb3React } from '../../hooks'
import useInterval from '../../hooks/useInterval'
import { useReviewAddress } from '../../hooks/commonNft/useContract'
import { useWalletModalToggle } from '../../state/application/hooks'
import { userMarketType } from '../../userType/userMarketType'
import SortPets, { OptionProps } from '../Pet/components/SortPets'
import { getArtworks, getArtworksV2, getArtworksV3 } from '../../service/nft'
import Row from '../../components/Row'
import useYam from '../../hooks/bakery/useYam'
import { userNftAddress } from '../../userType/userNftAddress'
import { userNFTMasterContract } from '../../userType/userNFTMasterContract'
import { userNFTContract } from '../../userType/userNFTContract'
import { NFTTYPE } from '../../constants/bakery/nft'
import { userBidNFTContract } from '../../userType/userBidNFTContract'
import { userExchangeNFTContract } from "../../userType/userExchangeNFTContract"
import { userV3NFTContract } from "../../userType/userV3NFTContract"
import { userNftTypeNum } from '../../userType/userNftTypeNum'
import { multiTokenExchangeNftContract } from '../../userType/multiTokenExchangeNftContract'
import { userNftSupportToken } from '../../userType/userNftSupportToken'
import DEFAULT_LIST from '../../constants/token/bakeryswap.json'
import useBakerySoccerRoi from '../../hooks/nft/useBakerySoccerRoi'
import useBlock from '../../hooks/bakery/useBlock'
import useBlockNum from '../../hooks/bakery/useBlockNum'
import { useBakeLevel } from '../../state/bakePool/hooks'

import {
  getAllStakingBakerySoccer,
  getAllStakingPokerCard,
  commonStakeERC721EarnERC20GetUserInfo,
  commonStakeERC721EarnBakeGetUserInfo,
  getAllStakingCarNFTs,
  getUserBids,
  getAsksByUser,
  getErc721Balance,
  getBmoncNftBalance,
  getNftHelperContract,
  getPokerBlindBoxAddress,
  getCarBlindBoxAddress,
  getBmoncNFTContract,
  getBmoncContract
} from '../../sushi/utils'
import { getUserBidsByNFT, getUserAsksByNFT } from '../../sushi/exchangeNFTs'

const UpToButtonLight = styled(ButtonLight)`
  margin-top: 160px;
  padding: 0px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: 80px;
  `}
`
const PageHead = styled.div`
  display: flex;
  width: 1204px;
  margin: 32px 0 28px;
  justify-content: space-between;
  box-sizing: border-box;
  flex-wrap: wrap;
  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    width: 904px;
  `}

  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 628px;
  `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 605px;
    flex-direction: column;
    align-items: center;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: calc(100% - 40px);
    justify-content: center;
  `}
`
const TabRow = styled(Row)`
  justify-content: flex-end;
  width: auto;
`
const ArtworksList = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 1204px;
  margin: auto;
  box-sizing: border-box;
  justify-content: flex-start;

  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    width: 904px;
  `}

  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 628px;
  `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 605px;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    padding: 0px 20px;
    justify-content: center;
  `}
`
const MyEggs = styled(NavLink)<{bg?: string; border?: string; color?: string}>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 174px;
  background: ${({ bg, theme }) => !bg && theme ? theme.primary1 : bg};
  border-radius: 10px;
  color: ${({ color, theme }) => !color && theme ? theme.bsText1 : color};
  font-family: Baloo Da;
  height: 40px;
  text-decoration: none;
  margin-right: 16px;
  border: ${({ border}) => (border ? '1px solid' : '0px solid') + border};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-right: 0;
    margin-bottom: 16px;
  `}
`

export default function MyArtworks ({history}: RouteComponentProps<{}>) {

  const theme = useContext(ThemeContext)
  const { chainId, account } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()
  const [loadingFlag, setLoadingFlag] = useState(false)
  const [artworks, setArtworks] = useState<any[]>([])
  const [curSelect, setCurSelect] = useState(SortOptions[5])
  const [curTab, setCurTab] = useState(TabOptions[0])
  const reviewAddress: any = useReviewAddress()
  const [canReview, setCanReview] = useState(false)
  const sushi = useYam()
  const nftHelper = getNftHelperContract(sushi)
  useEffect(() => {
    if (account && reviewAddress) {
      setCanReview(reviewAddress.includes(account))
    }
  }, [account, chainId, reviewAddress])
  const bakeLevel = useBakeLevel()
  const query:any = useParsedQueryString()
  const nftTypeQuery = query.type ? query.type.split('/') : []
  const level = ['v1', 'v2', 'v3']

  // 待审核
  const [curStatus, setCurStatus] = useState(1)
  const pending = useCallback(async (status) => {
    setCurStatus(status)
  }, [setCurStatus])

  const fetchAllArtworks = async (first?: boolean) => {
    if (first) {
      setLoadingFlag(true)
    }
    const lastList = {
      'v1': [],
      'v2': [],
      'v3': []
    }
    await Promise.all(
      level.map(async(v) => {
        await Promise.all(
          nftTypeQuery.map(async(nftNum: any) => {
            const type = userMarketType(nftNum, v)

            const nftAddress = type && userNftAddress(sushi, type)
            const listSet = new Set()
            let nftType: any[] = []
            let stakeList: any[] = []
            let bidList: any[] = []
            let askList: any[] = []
            let wattleList: any[] = []
            if (v === 'v3') {
              if (nftNum === '108') {
                nftType = [NFTTYPE.BARKING, NFTTYPE.BARKING_V2, NFTTYPE.BARKING_V3]
              } else if (nftNum === '117') {
                nftType = [NFTTYPE.BAKEMUSKMIXER, NFTTYPE.BAKEMUSKMIXER_V2, NFTTYPE.BAKEMUSKMIXER_V3]
              } else if (nftNum === '106') {
                nftType = [NFTTYPE.POKER, NFTTYPE.POKER_V2, NFTTYPE.POKER_V3]
              } else if (nftNum === '103') {
                nftType = [NFTTYPE.CAR, NFTTYPE.CAR_V2,, NFTTYPE.CAR_V3]
              } else if (nftNum === '100') {
                nftType = [NFTTYPE.SOCCER, NFTTYPE.SOCCER_V2, NFTTYPE.SOCCER_V3]
              } else if (nftNum === '104') {
                nftType = [NFTTYPE.DOGGIES, NFTTYPE.DOGGIES_V2, NFTTYPE.DOGGIES_V3]
              } else if (nftNum === '114') {
                nftType = [NFTTYPE.EQUIPMENT, NFTTYPE.EQUIPMENT_V2, NFTTYPE.EQUIPMENT_V3]
              }
            }
            nftType.forEach(async(stake) => {
              const list = await userStakes(stake)
              stakeList.push(...list)
            })
            bidList = type ? await userBids(type) : []
            askList = type ? await userAsks(type) : []

            if(type === MARKETTYPEV3.BINAMONV3 && chainId && chainId === 56){
              // 查询BmoncNFT余额
              wattleList = await getBmoncNftBalance(getBmoncContract(sushi), getBmoncNFTContract(sushi), account)
            }else{
              wattleList = v === 'v3' ? await getErc721Balance(nftHelper, nftAddress, account) : []
            }

            const asks: any[] = askList.map((d: any[]) => {
              return d[0]
            })

            const bids: any[] = bidList.map((d: any[]) => {
              return d[0]
            })
    
            asks.forEach((d) => {
              listSet.add(d.toString())
            })
            bids.forEach((d) => {
              listSet.add(d.toString())
            })
            stakeList.forEach((d) => {
              listSet.add(d.toString())
            })
            wattleList.forEach((d) => {
              listSet.add(d.toString())
            })

            const arr =  Array.from(listSet)
    
            const newArr = arr.map((item) => {
              return `${nftNum}-${item}`
            })
            lastList[v] = [...newArr.sort(compare('tokenId')), ...lastList[v]]
          })
        )
      })
    )

    const blindBoxs = await fetchBoxId()

    if (lastList.v1.length || lastList.v2.length || lastList.v3.length) {
      fetchAsksSort(curSelect, lastList, blindBoxs, first)
    }

    if (!lastList.v1.length && !lastList.v2.length && !lastList.v3.length) {
      if (blindBoxs.length) {
        setLoadingFlag(false)
        setArtworks(blindBoxs)
      } else {
        setLoadingFlag(false)
        setArtworks([])
      }
    }

  }

  const fetchBoxId = useCallback(async () => {
    let balanceArr: any = []
    const queryType = query.type
    const nftHelper = getNftHelperContract(sushi)
    let boxAddress
    let titleName: any
    let name: any
    let image: any
    let nftType: any
    switch (+queryType) {
      case 106:
          nftType = 106
          boxAddress = getPokerBlindBoxAddress(sushi)
          titleName = 'PET BlindBox'
          name = 'PET BlindBox'
          image = "/images/nft/blindbox.svg"
        break;
      case 103:
          nftType = 103
          boxAddress = getCarBlindBoxAddress(sushi)
          titleName = 'Rare Car Box'
          name = 'blindbox'
          image = "/images/nft/carbox.png"
        break;
      default:
        break;
    }
    if (!boxAddress) return []
    balanceArr = await getErc721Balance(nftHelper, boxAddress, account)
    const boxs = balanceArr.map((d: any) => {
      return {
        isBlindbox: true,
        nftType: nftType,
        tokenId: d,
        image: image,
        minImage: image,
        titleName: titleName,
        name: name,
        attributes: {
          stakingPower: 0
        }
      }
    })
    if (!boxs) return
    return boxs
  }, [account, sushi])

  const getDataV1 = (params: any) => {
    return new Promise((resolve, reject) => {
      getArtworks(chainId as number, params, (err: any, data: any) => {
        if (err) {
          reject()
          return
        }
        if (data.code !== 0) {
          reject()
          return
        }
        const dataAry = data.data.list || []
        dataAry.forEach((d: any) => {
          d.level = 'v1'
        })
        resolve(dataAry)
      })
    })
    .catch(() => [])
    .finally(() => {
      setLoadingFlag(false)
    })
  }
  const getDataV2 = (params: any) => {
    return new Promise((resolve, reject) => {
      getArtworksV2(chainId as number, params, (err: any, data: any) => {
        if (err) {
          reject()
          return
        }
        if (data.code !== 0) {
          reject()
          return
        }
        const dataAry = data.data.list || []
        dataAry.forEach((d: any) => {
          d.level = 'v2'
        })
        resolve(dataAry)
      })
    })
    .catch(() => [])
    .finally(() => {
      setLoadingFlag(false)
    })
  }
  const getDataV3 = (params: any) => {
    return new Promise((resolve, reject) => {
      getArtworksV3(chainId as number, params, (err: any, data: any) => {
        if (err) {
          reject()
          return
        }
        if (data.code !== 0) {
          reject()
          return
        }
        const dataAry = data.data.list || []
        dataAry.forEach((d: any) => {
          d.level = 'v3'
        })
        resolve(dataAry)
      })
    })
    .catch(() => [])
    .finally(() => {
      setLoadingFlag(false)
    })
  }

  const getNFTtype = useCallback((type) => {
    let typeConstant:any
    switch (+type) {
      case 104:
        if(bakeLevel === 'v1'){
          typeConstant = NFTTYPE.DOGGIES
        }
        if(bakeLevel === 'v2'){
          typeConstant = NFTTYPE.DOGGIES_V3
        }
        break;
      case 117:
        if(bakeLevel === 'v1'){
          typeConstant = NFTTYPE.BAKEMUSKMIXER
        }
        if(bakeLevel === 'v2'){
          typeConstant = NFTTYPE.BAKEMUSKMIXER_V3
        }
        break;
      case 108:
        if(bakeLevel === 'v1'){
          typeConstant = NFTTYPE.BARKING
        }
        if(bakeLevel === 'v2'){
          typeConstant = NFTTYPE.BARKING_V3
        }
        break;
      case 114:
        if(bakeLevel === 'v1'){
          typeConstant = NFTTYPE.EQUIPMENT
        }
        if(bakeLevel === 'v2'){
          typeConstant = NFTTYPE.EQUIPMENT_V3
        }
        break;
      case 106:
        if(bakeLevel === 'v1'){
          typeConstant = NFTTYPE.POKER
        }
        if(bakeLevel === 'v2'){
          typeConstant = NFTTYPE.POKER_V3
        }
        break;
      case 103:
        if(bakeLevel === 'v1'){
          typeConstant = NFTTYPE.CAR
        }
        if(bakeLevel === 'v2'){
          typeConstant = NFTTYPE.CAR_V3
        }
        break;
      case 100:
        if(bakeLevel === 'v1'){
          typeConstant = NFTTYPE.SOCCER
        }
        if(bakeLevel === 'v2'){
          typeConstant = NFTTYPE.SOCCER_V3
        }
        break;
    }
    return typeConstant
  }, [bakeLevel])

  const gameType = nftTypeQuery[0] === '107' ? '117' : nftTypeQuery[0]
  const testNftType = getNFTtype(gameType)

  // 计算apy
  const roiType = getNFTtype(gameType)
  const currentBlock = useBlock()
  const blockNum = useBlockNum(currentBlock)
  const doggyRoi = useBakerySoccerRoi(blockNum as BigNumber, roiType)

  const fetchAsksSort = async (rank: OptionProps, noInfoArts: any, box?: any, loading?: boolean) => {
    if (loading) {
      setLoadingFlag(true)
    }
    let params = {
      fileType: +curTab.sortName,
      sortName: rank.sortName,
      sortBy: rank.sortBy,
      status: curStatus
    }
    if (+params.fileType === 0) {
      (params.fileType as (string | number)) = ''
    }


    const idsV1 = noInfoArts.v1.join(',')
    const idsV2 = noInfoArts.v2.join(',')
    const idsV3 = noInfoArts.v3.join(',')
    const paramsV1 = {
      ...params,
      ids: idsV1
    }
    const paramsV2 = {
      ...params,
      ids: idsV2
    }
    const paramsV3 = {
      ...params,
      ids: idsV3
    }

    const handleDataArtworks = (arr: any) => {
      let allTokens = DEFAULT_LIST.tokens
      let titleName = ''
      let nftName = ''
      let showBorder = false
      let isCanTransfer = true
      let isCanStake= true
      const artworks = arr.map((d: ArtworkProps) => {
        let tokenName: string = userNftSupportToken(d.nftType)
        for(let i = 0;i < allTokens.length;i++){
          if(d.quoteToken && d.quoteToken.toLowerCase() === allTokens[i].address.toLowerCase()){
            tokenName = allTokens[i].symbol.toUpperCase()
          }
        }
        switch (+d.nftType) {
          case 104:
              titleName = 'Crypto Doggy'
            break;
          case 106:
              titleName = 'PET PokerCard'
              isCanTransfer = false
            break;
          case 108:
              titleName = 'Barking'
              isCanTransfer = false
              nftName = 'Barking NFT'
            break;
          case 103:
            titleName = 'CAR Model'
            isCanTransfer = false
            nftName = 'Barking NFT'
          break;
        }
        return {
          ...d,
          tokenId: d.nftId,
          tokenName: tokenName,
          roi: doggyRoi,
          titleName: titleName,
          showBorder: showBorder,
          isCanTransfer: isCanTransfer,
          image: d.fileUrl,
          isCanStake: isCanStake,
          nftName: nftName,
          maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
          ...((d.attributes.minImage) ? {minImage: d.attributes.minImage}: {}),
          ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
          ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
        }
      })
      return artworks
    }

    let listV1
    let listV2
    let listV3
    // let bmoncList

    if (idsV1) {
      listV1 = await getDataV1(paramsV1)
    } else {
      listV1 = []
    }
    if (idsV2) {
      listV2 = await getDataV2(paramsV2)
    } else {
      listV2 = []
    }
    if (idsV3) {
      listV3 = await getDataV3(paramsV3)
    } else {
      listV3 = []
    }

    const artworksV1 = handleDataArtworks(listV1)
    const artworksV2 = handleDataArtworks(listV2)
    const artworksV3 = handleDataArtworks(listV3)
    setLoadingFlag(false)
    setArtworks([...box, ...artworksV3, ...artworksV2, ...artworksV1])
  }

  const updateData = useCallback((d) => {
    setCurSelect(d)
  }, [])

  const upTab = useCallback((d) => {
    setCurTab(d)
  }, [])

  useEffect(() => {
    if (account) {
      fetchAllArtworks(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, curSelect, chainId, curStatus, curTab])

  const userStakes = useCallback(async(type) => {
    if (!type) return []
    try {
      let exchangeNFTContract: any = userNFTMasterContract(sushi, type)
      let exchangeContract: any = userNFTContract(sushi, type)
      let userBids: any
      if(type && [NFTTYPE.SOCCER].includes(type)){
        userBids = await getAllStakingBakerySoccer(exchangeNFTContract, account)
      }else if(type && [NFTTYPE.POKER].includes(type)){
        let Arr = await getAllStakingPokerCard(exchangeNFTContract, exchangeContract, account)
        userBids = Arr.map((d: any) => {
          return d.tokenId
        })
      }else if(type && [NFTTYPE.GAMEBOX].includes(type)){
        let Arr = await commonStakeERC721EarnERC20GetUserInfo(exchangeNFTContract, exchangeContract, account)
        userBids = Arr[2]
      }else if(type && [NFTTYPE.CAR].includes(type)){
        let Arr = await getAllStakingCarNFTs(exchangeNFTContract, exchangeContract, account)
        userBids = Arr.map((d: any) => {
          return d.tokenId
        })
      }else if(type && [
        NFTTYPE.CAR_V2,
        NFTTYPE.DOGGIES, 
        NFTTYPE.DOGGIES_V2,
        NFTTYPE.BARKING,
        NFTTYPE.BARKING_V2,
        NFTTYPE.MATRIX,
        NFTTYPE.POKER_V2,
        NFTTYPE.EQUIPMENT,
        NFTTYPE.EQUIPMENT_V2,
        NFTTYPE.BAKEMUSKMIXER,
        NFTTYPE.BAKEMUSKMIXER_V2,
        NFTTYPE.SOCCER_V2,
        NFTTYPE.COMBO_V2,
        NFTTYPE.DOGGIES_V3,
        NFTTYPE.BARKING_V3,
        NFTTYPE.EQUIPMENT_V3,
        NFTTYPE.BAKEMUSKMIXER_V3,
        NFTTYPE.CAR_V3,
        NFTTYPE.COMBO_V3,
        NFTTYPE.SOCCER_V3,
        NFTTYPE.POKER_V3, 
      ].includes(type)){
        let Arr = await commonStakeERC721EarnBakeGetUserInfo(exchangeNFTContract, account)
        userBids =[...Arr[2]]
      }
      const list = userBids.map((d: any) => {
        return d
      })
      return list
    } catch (e) {
      console.log(e)
      return []
    }
  }, [account])

  const userBids = useCallback(async(type) => {
    let exchangeNFTContract: any
    let isMultiToken:boolean = false

    if(type && MARKETTYPE.hasOwnProperty(type)){
      exchangeNFTContract = userBidNFTContract(sushi, type)
      isMultiToken = false
    }else if(type && MARKETMULTITOKEN.hasOwnProperty(type)){
      exchangeNFTContract = multiTokenExchangeNftContract(sushi, type)
      isMultiToken = true
    }else if(type && MARKETTYPEV1.hasOwnProperty(type)){
      exchangeNFTContract = userExchangeNFTContract(sushi, type)
    }else if(type && MARKETTYPEV3.hasOwnProperty(type)){
      exchangeNFTContract = userV3NFTContract(sushi, type)
      isMultiToken = true
    }
    try {
      let userBids: any[] = []
      if(!isMultiToken) {
        userBids = await getUserBids(exchangeNFTContract, account)
      }else {
        if(type && MARKETMULTITOKEN.hasOwnProperty(type) || (type && MARKETTYPEV3.hasOwnProperty(type))){
          let nftAddress = userNftAddress(sushi, type)
          let nftType = userNftTypeNum(type)
          let curTokenBids = await getUserBidsByNFT(exchangeNFTContract, nftAddress, account)
          userBids = curTokenBids.map((d: any) => {
            return [
              d.tokenId,
              d.price,
              d.quote,
              nftType
            ]
          })
        }
      }
      
      const list = userBids.map((d: any) => {
        return {
          ...d,
          type: 'BID'
        }
      })
      return list
    } catch (e) {
      return []
    }
  }, [account, sushi])
  const userAsks = useCallback(async(type) => {
    try {
      let userAsks: any[] = []
      let exchangeNFTContract: any
      let isMultiToken:boolean = false
  
      if(type && MARKETTYPE.hasOwnProperty(type)){
        exchangeNFTContract = userBidNFTContract(sushi, type)
        isMultiToken = false
      }else if(type && MARKETMULTITOKEN.hasOwnProperty(type)){
        exchangeNFTContract = multiTokenExchangeNftContract(sushi, type)
        isMultiToken = true
      }else if(type && MARKETTYPEV1.hasOwnProperty(type)){
        exchangeNFTContract = userExchangeNFTContract(sushi, type)
      }else if(type && MARKETTYPEV3.hasOwnProperty(type)){
        exchangeNFTContract = userV3NFTContract(sushi, type)
        isMultiToken = true
      }
      if(!isMultiToken) {
        userAsks = await getAsksByUser(exchangeNFTContract, account)
      }else {
        if(type && MARKETMULTITOKEN.hasOwnProperty(type) || (type && MARKETTYPEV3.hasOwnProperty(type))){
          let nftAddress = userNftAddress(sushi, type)
          let curTokenAsks = await getUserAsksByNFT(exchangeNFTContract, nftAddress, account)
          userAsks = curTokenAsks.map((d: any) => {
            return [
              d.tokenId,
              d.price
            ]
          })
        }
      }
      const list = userAsks.map((d: any) => {
        return {
          ...d,
          type: 'ASK'
        }
      })
      return list
    } catch (e) {
      return []
    }
  }, [account, sushi])

  const getSolt = useCallback((d) => {
    let solt: any
    switch (+d.nftType) {
      case 104:
        solt = <DoggyInfoSolt artwork={d} />
        break;
      case 108:
        solt = <BarkInfoSolt artwork={d} />
        break;
      case 114:
        solt = <EquipmentInfoSolt artwork={d} />
        break;
      case 106:
        solt = <PokerInfoSolt artwork={d} />
        break;
      case 103:
        solt = <CarInfoSolt artwork={d} type={getNFTtype(d.nftType)} isMyArtwork={true} />
        break;
    }
    return solt
  }, [])

  const titleName = {
    '104': 'My Crypto Doggy NFTs',
    '108': 'My Barking NFTs',
    '114': 'My Doggy Equipment',
    '106': 'My Poker BlindBox NFTs',
    '103': 'My CAR NFT',
    '100': 'My Soccer NFT'
  }
  const tips = {
    '103': `Wish you could get your best CAR NFTs 😋`,
    '100': `Wish you could get your best Soccer NFT 😋`
  }
  useInterval(fetchAllArtworks, account ? 10000 : null)

  return (
    <>
      <Loading open={loadingFlag} />
      {
        !account ? (
          <UpToButtonLight width={'180px'} height={40} onClick={toggleWalletModal}>
            Connect Wallet
          </UpToButtonLight>
          ) : <>
            <BodyHead>
              <BodyTitle fontSize={32} fontWeight={700}>{titleName[nftTypeQuery[0]] ? titleName[nftTypeQuery[0]] : 'My Artworks'}</BodyTitle>
              <Text fontSize={16}>
                {tips[nftTypeQuery[0]] ? tips[nftTypeQuery[0]] : 'Your wonderful artworks are here!'}
              </Text>
            </BodyHead>
            {
              [104, 108, 114, 106, 103, 100, 107].includes(+nftTypeQuery[0]) ?
              <>
                <ExchangeBakeVersion />
                <StakeRow type={testNftType} />
              </> : null
            }
            
            <PageHead>
                <MyEggs to={`/my-new-artworks?type=${query.type}`} bg={theme.bsBg1} color={theme.bsText7} border={theme.bsText7}
                  onClick={() => {pending(curStatus === 0 ? 1 : 0)}}>
                  <Text marginLeft={12} marginRight={12}>{ curStatus === 1 ? 'Pending' : 'Reviewed'}</Text>
                </MyEggs>
              <TabRow>
                <SortPets
                  margin="0 15px 0 0"
                  curSelect={curTab}
                  options={TabOptions}
                  updateData={upTab}
                ></SortPets>
                <SortPets
                  wd='110px'
                  curSelect={curSelect}
                  options={SortOptions}
                  updateData={updateData}
                ></SortPets>
              </TabRow>
            </PageHead>
            {
              loadingFlag
                ? null
                : !account || artworks.length === 0 ? (
                  <NoArtworks type={nftTypeQuery[0]} nftTypeQuery={nftTypeQuery} ownBtn={true} status={curStatus} />
                ) : (
                  <>
                    <ArtworksList>
                      {
                        artworks.map((d) => {
                          return (
                             d.nftType === 2 ?
                              <Videos
                                key={d.tokenId}
                                video={d}
                                history={history}
                                isMyBinanceNft={true}
                                nftType={userMarketType(d.nftType, d.level)}
                              /> : [104, 108, 114, 106, 103].includes(+d.nftType) ?
                              <GameArtworks
                                key={d.tokenId}
                                artwork={d}
                                artworklength={artworks.length}
                                type={getNFTtype(d.nftType)}
                                nftType={userMarketType(d.nftType, d.level)}
                                isMyArtwork={true}
                                showBorder={d.showBorder}
                                isBlindbox={d.isBlindbox}
                                isCanTransfer={d.isCanTransfer}
                                isCanStake={d.isCanStake}
                                tokenName={d.tokenName}
                                solt={getSolt(d)}
                              /> : [100].includes(+d.nftType) ? 
                              <SoccerArtwork
                                key={d.tokenId}
                                marketType={userMarketType(d.nftType, d.level)}
                                type={getNFTtype(d.nftType)}
                                artwork={d}
                                status={curStatus}
                                canReview={false}
                                isMyArtwork={true}
                                history={history}
                              /> 
                               :
                                <Artworks 
                                  key={d.id}
                                  artwork={d}
                                  isMyArtwork={true}
                                  status={curStatus}
                                  canReview={canReview}
                                  history={history}
                                  tokenName={d.tokenName}
                              />
                          )
                        })
                      }
                    </ArtworksList>
                  </>
                )
            }
          </>
      }
    </>
  )
}